<template>
	<div class="navban-component">
		<ul>
			<slot name="navabanli"></slot>
		</ul>
	</div>
</template>
<script>
export default {
    mounted() {
        
    }
}
</script>
<style lang="less">
	@rem: 40rem;
	@w100: 640/@rem;
	.justify{
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
	}
	.navban-component{
		width: @w100;
		ul{
			&:extend(.justify);
		}
	}
</style>